module.exports = __webpack_public_path__ + "static/media/Fb1.69047b32.png";